import { render, staticRenderFns } from "./SalesDataDetailDialog.vue?vue&type=template&id=2a8e20b6&scoped=true&"
import script from "./SalesDataDetailDialog.vue?vue&type=script&lang=js&"
export * from "./SalesDataDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./SalesDataDetailDialog.vue?vue&type=style&index=0&id=2a8e20b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8e20b6",
  null
  
)

export default component.exports